/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: ToggleButton.tsx
 * Project: mle-client-n
 * Committed last: 2022/11/11 @ 164
 * ---
 * Description:
 */


import {Button, ButtonProps, IconName, Intent} from "@blueprintjs/core";

interface BaseToggleButtonProps {
    buttonProps?: ButtonProps;
    checked: boolean;
    onToggle: () => void;
    affirmativeText: string;
    negativeText: string;
    affirmativeIcon: IconName;
    negativeIcon: IconName;
}

export const ToggleButton = (props: BaseToggleButtonProps) => {

    return (
        <Button
            intent={Intent.PRIMARY}
            {...props.buttonProps}
            onClick={props.onToggle}
            icon={props.checked ? props.affirmativeIcon : props.negativeIcon}>
            {
                props.checked ? props.affirmativeText : props.negativeText
            }
        </Button>
    )
}